export enum ActionType {
  ROLE_CREATE = 'ROLE_CREATE',
  ROLE_UPDATE = 'ROLE_UPDATE',
  ROLE_DELETE = 'ROLE_DELETE',
  ADMIN_CREATE = 'ADMIN_CREATE',
  ADMIN_UPDATE = 'ADMIN_UPDATE',
  ADMIN_DELETE = 'ADMIN_DELETE',
  KYC_APPROVE = 'KYC_APPROVE',
  KYC_VIEW = 'KYC_VIEW',
  TICKET_CREATE = 'TICKET_CREATE',
  TICKET_DELETE = 'TICKET_DELETE',
  CHAT_LEAVE = 'CHAT_LEAVE',
  MESSAGE_SEND = 'MESSAGE_SEND',
  USER_BLOCK = 'USER_BLOCK',
  USER_UNBLOCK = 'USER_UNBLOCK',
  USER_DISABLE_2FA = 'USER_DISABLE_2FA',
  USER_BALANCE_UPDATE = 'USER_BALANCE_UPDATE',
  DEPOSIT_APPROVE = 'DEPOSIT_APPROVE',
  DEPOSIT_REJECT = 'DEPOSIT_REJECT',
  WITHDRAW_APPROVE = 'WITHDRAW_APPROVE',
  WITHDRAW_REJECT = 'WITHDRAW_REJECT',
  LOGS_EXPORT_CSV = 'LOGS_EXPORT_CSV',
}

export interface RolePermissions {
  read: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
}

export interface RoleData {
  name?: string;
  description?: string;
  permissions?: Record<string, RolePermissions>;
}

export interface AdminData {
  name?: string;
  login?: string;
  email?: string;
  role?: string;
  isActive?: boolean;
  telegramId?: string;
  password?: string;
}

export interface UserData {
  id?: string;
  coinsFlyId?: string;
}

export interface BalanceUpdateValue {
  userId?: string;
  coinsFlyId?: string;
  currency?: string;
  balanceType?: string;
  amount?: string;
  amountRaw?: string;
}

export interface TicketData {
  id?: string;
}

export interface ChatData {
  id?: string;
}

export interface OrderData {
  id?: string;
}

export interface AdminLogsExportOldValue {
  adminLogin?: string;
  filters?: Record<string, unknown>;
}

export interface AdminLogsExportNewValue {
  fileName: string;
  targetAdminLogin: string | null;
  exportedAt: string;
}

export type LogValue =
  | RoleData
  | AdminData
  | UserData
  | BalanceUpdateValue
  | TicketData
  | ChatData
  | OrderData
  | AdminLogsExportOldValue
  | AdminLogsExportNewValue
  | Record<string, unknown>;

export interface IAdminLog {
  id: string;
  admin_id: string;
  action_type: ActionType;
  target_entity_type?: string;
  target_entity_id?: string;
  description?: string;
  metadata?: Record<string, unknown>;
  old_value?: LogValue;
  new_value?: LogValue;
  created_at: string;
  admin?: {
    id: string;
    email: string;
    name?: string;
  };
}

export interface IAdminLogsParams {
  page?: number;
  pageSize?: number;
  searchValue?: string;
  sortBy?: string;
  sortOrder?: string;
  filter?: Record<string, string>;
}
